@if (formControl()) {
  <mat-radio-group
    class="u-radio-button {{ styleClass() }}"
    [formControl]="formControl()"
    (change)="onRadioButtonClick($event.value)"
    [disabled]="stateElement() === 'disabled'"
    [class.two-lines]="hasTwoLines()"
  >
    @for (option of options(); track option.value) {
      <div class="u-radio-option">
        <mat-radio-button class="u-radio-button" [value]="option.value" [disabled]="option.disabled" [class.has-subtitle]="hasTwoLines()">
          <ng-container *ngTemplateOutlet="optionTemplateHtml; context: { $implicit: option, option: option }"></ng-container>
        </mat-radio-button>
        @if (optionTemplate() && (showTemplateForAll() || formControl()?.value === option.value)) {
          <ng-container *ngTemplateOutlet="optionTemplate(); context: { $implicit: option, option: option }"></ng-container>
        }
      </div>
    }
  </mat-radio-group>
} @else {
  <mat-radio-group
    class="u-radio-button {{ styleClass() }}"
    [(ngModel)]="selectedOption"
    (change)="onRadioButtonClick($event.value)"
    [disabled]="stateElement() === 'disabled'"
  >
    @for (option of options(); track option.value) {
      <div>
        <mat-radio-button class="u-radio-button" [value]="option.value" [disabled]="option.disabled" [class.has-subtitle]="hasTwoLines()">
          <ng-container *ngTemplateOutlet="optionTemplateHtml; context: { $implicit: option, option: option }"></ng-container>
        </mat-radio-button>
        <ng-container *ngIf="optionTemplate() && (showTemplateForAll() || selectedOption() === option.value)">
          <ng-container *ngTemplateOutlet="optionTemplate(); context: { $implicit: option, option: option }"></ng-container>
        </ng-container>
      </div>
    }
  </mat-radio-group>
}

<ng-template #optionTemplateHtml let-option>
  <div class="u-radio-labels">
    <div class="u-radio-label">{{ option.label }}</div>
    @if (option.subtitle) {
      <div class="u-radio-subtitle">{{ option.subtitle }}</div>
    }
  </div>
</ng-template>
